import { type JSX } from "react";
import type { ISvgIcon } from "@/types";

export function ICWallet({ width, height, className }: ISvgIcon): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6669 7.3128V8.68613C14.6669 9.0528 14.3735 9.3528 14.0002 9.36613H12.6935C11.9735 9.36613 11.3135 8.83947 11.2535 8.11947C11.2135 7.69947 11.3735 7.30613 11.6535 7.0328C11.9002 6.77947 12.2402 6.63281 12.6135 6.63281H14.0002C14.3735 6.64615 14.6669 6.94613 14.6669 7.3128Z"
        fill="white"
      />
      <path
        d="M13.6467 10.3666H12.6934C11.4267 10.3666 10.36 9.41331 10.2534 8.19998C10.1934 7.50665 10.4467 6.81331 10.9534 6.31998C11.38 5.87998 11.9734 5.63331 12.6134 5.63331H13.6467C13.84 5.63331 14 5.47331 13.98 5.27998C13.8334 3.65998 12.76 2.55331 11.1667 2.36665C11.0067 2.33998 10.84 2.33331 10.6667 2.33331H4.66671C4.48004 2.33331 4.30004 2.34665 4.12671 2.37331C2.42671 2.58665 1.33337 3.85331 1.33337 5.66665V10.3333C1.33337 12.1733 2.82671 13.6666 4.66671 13.6666H10.6667C12.5334 13.6666 13.82 12.5 13.98 10.72C14 10.5266 13.84 10.3666 13.6467 10.3666ZM8.66671 6.49998H4.66671C4.39337 6.49998 4.16671 6.27331 4.16671 5.99998C4.16671 5.72665 4.39337 5.49998 4.66671 5.49998H8.66671C8.94004 5.49998 9.16671 5.72665 9.16671 5.99998C9.16671 6.27331 8.94004 6.49998 8.66671 6.49998Z"
        fill="white"
      />
    </svg>
  );
}
